export interface QuestionAttemptsTrackingState {
  id: string
  attempts: QuestionAttemptTrackingState[]
}

export interface QuestionAttemptTrackingState {
  thinkingTimeSeconds: number
  achievedScore: number
}

export function defaultQuestionAttemptsTrackingState(id: string): QuestionAttemptsTrackingState {
  return {
    id,
    attempts: []
  }
}
